import { MercuryBundles } from "@genexus/mercury";
import { Component, Element, Host, Prop, h } from "@stencil/core";
import { formatDate } from "../../../common/helpers";
import { Locale } from "../../../common/locale";

const CSS_BUNDLES: MercuryBundles = [
  "resets/box-sizing",
  "utils/form--full",
  "utils/layout",
  "utils/typography",
  "utils/spacing",
  "chameleon/scrollbar"
];

@Component({
  tag: "gx-ide-comments-viewer",
  styleUrl: "comments-viewer.scss",
  shadow: true,
  assetsDirs: ["gx-ide-assets/comments-viewer"]
})
export class GxIdeCommentsViewer {
  #componentLocale: any;
  @Element() el: HTMLGxIdeCommentsViewerElement;

  /**
   * Comments data to display
   */
  @Prop() readonly commentsData: CommentData[] = [];

  /**
   * Callback to be executed when the user closes the viewer
   */
  @Prop() readonly closeCallback!: () => Promise<void>;

  async componentWillLoad() {
    this.#componentLocale = await Locale.getComponentStrings(this.el);
  }

  #renderCommentItem = (commentData: CommentData) => {
    return (
      <div class="comment-item">
        <header>
          <span class="body-semi-bold-s comment-title">
            {formatDate(new Date(commentData.date))} - {commentData.user}
          </span>
        </header>

        <p class="body-regular-m">{commentData.comment}</p>
      </div>
    );
  };

  #renderFooter = () => {
    return (
      <footer class="control-footer-with-border spacing-body">
        <div class="buttons-spacer">
          <button class="button-primary" onClick={this.#closeHandler}>
            {this.#componentLocale.buttons.close}
          </button>
        </div>
      </footer>
    );
  };

  #closeHandler = async () => {
    await this.closeCallback();
  };

  render() {
    return (
      <Host class="widget">
        <ch-theme model={CSS_BUNDLES}></ch-theme>
        <div class="spacing-body comments-container scrollable">
          <ul class="comments-list">
            {this.commentsData.map((comment, idx) => (
              <li class="row">
                {this.#renderCommentItem(comment)}

                {idx < this.commentsData.length - 1 && <hr class="divider" />}
              </li>
            ))}
          </ul>
        </div>
        {this.#renderFooter()}
      </Host>
    );
  }
}

export type CommentData = {
  date: string;
  user: string;
  comment: string;
};
